<template>
  <Transition name="list">
    <LoadingToast
      v-if="loading === true"
      title="Page Loading"
      description="Please wait..."
    />
  </Transition>
</template>

<script setup lang="ts">
const router = useRouter()
const loading = ref(false)

router.beforeEach(() => (loading.value = true))
router.afterEach(() => (loading.value = false))
</script>
